import { render } from "./SpendingAnalysisPage.vue?vue&type=template&id=48307914&scoped=true"
import script from "./SpendingAnalysisPage.vue?vue&type=script&lang=js"
export * from "./SpendingAnalysisPage.vue?vue&type=script&lang=js"

import "./SpendingAnalysisPage.vue?vue&type=style&index=0&id=48307914&scoped=true&lang=css"
import "./SpendingAnalysisPage.vue?vue&type=style&index=1&id=48307914&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48307914"]])

export default __exports__